import { render, staticRenderFns } from "./BlocoDadosCarVinculadosMonitoramentoSocioambiental.vue?vue&type=template&id=1194f190&scoped=true&lang=pug"
import script from "./BlocoDadosCarVinculadosMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./BlocoDadosCarVinculadosMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosCarVinculadosMonitoramentoSocioambiental.vue?vue&type=style&index=0&id=1194f190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1194f190",
  null
  
)

export default component.exports